import useSWR from 'swr';

export type CryptoFinancialPeriod = 'quarterly' | 'annual';

export interface CryptoFinancialMetric {
  period_label: string;
  fees: number;
  revenue: number;
  expenses: number;
  supply_side_fees: number;
  token_incentives: number;
  earnings: number;
}

export interface CryptoFinancialsResponse {
  symbol: string;
  period: CryptoFinancialPeriod;
  data: CryptoFinancialMetric[];
}

export function useCryptoFinancials(symbol: string, period: CryptoFinancialPeriod) {
  return useSWR<CryptoFinancialsResponse>(
    `api:/market/crypto/${symbol}/financials?period=${period}`,
  );
}
